import { render, staticRenderFns } from "./StationSave.vue?vue&type=template&id=8bead1ec&"
import script from "./StationSave.vue?vue&type=script&lang=js&"
export * from "./StationSave.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports